import ClockDashkIcon from "@svg/new-design/clock-dash";
import { DetailsExpire, EXPIRY_STATUS } from "@types";
import { toFarsiNumber } from "@utils/digits";
import classNames from "classnames";
import { FC, useMemo } from "react";

interface Props {
  details_expire: DetailsExpire;
}
const BadgeCoupon: FC<Props> = ({ details_expire }) => {
  const { window_end_at_formatted, expiry_status } = details_expire;

  const state = useMemo(() => {
    if (!window_end_at_formatted) {
      return {
        bgClass: "bg-fds-accent",
        label: "",
      };
    }

    const expireTs = new Date(
      (window_end_at_formatted || "").replace("Z", "")
    ).getTime();

    const diffMs = Math.max(0, expireTs - Date.now());
    const totalHours = Math.ceil(diffMs / (1000 * 60 * 60));
    const DAY_MS = 1000 * 60 * 60 * 24;
    const days = diffMs / DAY_MS;

    const totalDays = days <= 0 ? 0 : days < 2 ? 1 : Math.floor(days);

    const isLongWindow = totalDays > 10;
    const bgClass =
      expiry_status === EXPIRY_STATUS.EXPIRABLE
        ? isLongWindow
          ? "bg-fds-accent"
          : "bg-fds-danger"
        : "bg-fds-inverse-secondary";

    const unit = totalHours <= 24 ? "ساعت" : "روز";
    const value = totalHours <= 24 ? totalHours : totalDays;

    const label =
      expiry_status === EXPIRY_STATUS.EXPIRABLE
        ? totalDays <= 10
          ? `${toFarsiNumber(value)} ${unit} تا پایان مهلت دسترسی`
          : `${toFarsiNumber(value)} ${unit} دسترسی رایگان به آموزش`
        : "پایان مهلت مشاهده رایگان";

    return { bgClass, label };
  }, [window_end_at_formatted]);

  if (!state.label) return null;

  return (
    <div
      className={classNames(
        state.bgClass,
        "h-6 flex items-center absolute bottom-0 inset-x-0 w-full justify-center gap-1.5 text-fds-on-accent rounded-b-6"
      )}
      aria-live="polite"
      title={state.label}
    >
      <ClockDashkIcon />
      <p className="body-md">{state.label}</p>
    </div>
  );
};

export default BadgeCoupon;
